// extracted by mini-css-extract-plugin
module.exports = {"Navigation__title":"Navigation_Navigation__title__XSWEn","Navigation__sticker":"Navigation_Navigation__sticker__31QSL"};